import { takeLatest, all, put } from 'redux-saga/effects'
import * as calls from './calls'
import * as reducerActions from '../../reducers/usuarioReducer/actions'
import * as pedidoActions from '../../reducers/pedidosReducer/actions'
import * as layoutActions from '../../reducers/layoutReducer/actions'
import * as Notifications from '../../components/Common/notification'

function* genGetNuevosUsuarios(e) {
  try {
    // llamo a la acción que trae los rubros
    let nu = yield calls.getNuevosUsuarios(e.payload.page)
    yield put(reducerActions.setNuevosUsuarios(nu))
    yield put(reducerActions.setUsuarioHabilitado(false))
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  }
}

function* genGetUsuarios(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Obteniendo usuarios' })
    )

    // llamo a la acción que trae los rubros
    let nu = yield calls.getUsuarios(e.payload)
    yield put(reducerActions.setUsuarios(nu))
    yield put(reducerActions.setUsuarioHabilitado(false))
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genHabilitarUsuario(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Habilitando usuario' })
    )

    let result = yield calls.HabilitarUsuario(e.payload)
    yield put(reducerActions.setUsuarioHabilitado(result, e.payload.id))
    Notifications.showSuccess('Usuario habilitado')
    yield put(reducerActions.sagaGetNuevosUsuarios(e.page))
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genGetUsuario(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Recuperando usuario' })
    )

    let result = yield calls.getUsuario(e.payload.id)
    yield put(reducerActions.saveUsuario(result))
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genSaveUsuario(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Guardando usuario' })
    )

    let result = yield calls.saveUsuario(e.payload)
    if (result === '') {
      if (e.payload.tipoRol === 1 && e.payload.id === null)
        Notifications.showSuccess('Usuario interno creado')
      if (e.payload.id !== null)
        Notifications.showSuccess('Usuario actualizado ')

      if (e.history !== undefined) {
        e.history.goBack()
      }
    } else {
      Notifications.showError(result)
    }
    //yield put(reducerActions.saveUsuario(result))
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genEliminiarUsuario(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Desactivando usuario' })
    )

    yield calls.eliminarUsuario(e.payload)
    Notifications.showSuccess('Usuario eliminado')
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genReactivarUsuario(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Reactivando usuario' })
    )

    yield calls.reactivarUsuario(e.payload)
    Notifications.showSuccess('Usuario reactivado')
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genConfirmarUsuario(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Confirmando usuario' })
    )

    yield calls.confirmarUsuario(e.payload)
    Notifications.showSuccess('Correo electrónico confirmado')
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}
function* genMailUsuario(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({ show: true, message: 'Enviando confirmación' })
    )

    yield calls.enviarConfirmacionUsuario(e.payload)
    Notifications.showSuccess('Correo reenviado')
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genReestablecerUsuario(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({
        show: true,
        message: 'Restableciendo contraseña',
      })
    )

    yield calls.reestablecerUsuario(e.payload)
    //Notifications.showSuccess("Contraseña restablecida")
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genGetLocalidades(e) {
  try {
    let result = yield calls.getLocalidades(e.nombre)
    yield put(reducerActions.saveLocalidades(result))
  } catch (e) {
    Notifications.showError(e.error)
  }
}

function* genSaveDireccionEntrega(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({
        show: true,
        message: 'Guardando dirección de entrega',
      })
    )

    // hago la llamada a la call
    let direccion = yield calls.saveDireccionEntrega(e.payload)

    //seteo la notificacion como lista
    yield put(pedidoActions.setdireccionesEntrega(direccion))

    if (e.payload.callback) {
      e.payload.callback(direccion)
    }
  } catch (error) {
    if (e.payload.callbackError) {
      e.payload.callbackError(error.error)
    }

    if (error.Message) {
      return
    }
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genAgregarListaBlanca(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({
        show: true,
        message: 'Agregando cliente a lista blanca',
      })
    )

    yield calls.agregarListaBlanca(e.payload)
    Notifications.showSuccess('Cliente en Lista Blanca')
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genEliminarListaBlanca(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({
        show: true,
        message: 'Eliminando cliente de lista blanca',
      })
    )

    yield calls.eliminarListaBlanca(e.payload)
    Notifications.showSuccess('Cliente removido de Lista Blanca')
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genAgregarListaNegra(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({
        show: true,
        message: 'Agregando cliente a lista negra',
      })
    )

    yield calls.agregarListaNegra(e.payload)
    Notifications.showSuccess('Cliente en Lista Negra')
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genEliminarListaNegra(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({
        show: true,
        message: 'Eliminando cliente de lista negra',
      })
    )

    yield calls.eliminarListaNegra(e.payload)
    Notifications.showSuccess('Cliente removido de Lista Negra')
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
  }
}

function* genSetSucursalesUsuario(e) {
  try {
    // muestro el loader
    yield put(
      layoutActions.setLoading({
        show: true,
        message: 'Modificando sucursales del usuario',
      })
    )

    yield calls.setSucursalesUsuario(e.payload)
    Notifications.showSuccess('Sucursales del usuario modificado con éxito')
  } catch (e) {
    // muestro el mensaje de error
    Notifications.showError(e.error)
  } finally {
    // oculto el loader
    yield put(layoutActions.setLoading({ show: false }))
    if (
      e.payload.usuarioLogueadoId === e.payload.idUsuario &&
      e.payload.desactivas.find((x) => x === e.payload.idSucursalActual)
    )
      window.location.hash = '/SeleccionSucursal'
  }
}

function* defaultSaga() {
  yield all([
    takeLatest(reducerActions.SAGA_GET_NUEVOS_USUARIOS, genGetNuevosUsuarios),
    takeLatest(reducerActions.SAGA_GET_USUARIOS, genGetUsuarios),
    takeLatest(reducerActions.SAGA_HABILITAR, genHabilitarUsuario),
    takeLatest(reducerActions.SAGA_GET_USUARIO_BY_ID, genGetUsuario),
    takeLatest(reducerActions.SAGA_SAVE_USUARIO, genSaveUsuario),
    takeLatest(reducerActions.SAGA_ELIMINAR_USUARIO, genEliminiarUsuario),
    takeLatest(reducerActions.SAGA_REACTIVAR_USUARIO, genReactivarUsuario),
    takeLatest(reducerActions.SAGA_CONFIRMAR_USUARIO, genConfirmarUsuario),
    takeLatest(reducerActions.SAGA_MAIL_CONFIRMAR_USUARIO, genMailUsuario),
    takeLatest(
      reducerActions.SAGA_REESTABLECER_CONTRASENIA,
      genReestablecerUsuario
    ),
    takeLatest(reducerActions.SAGA_GET_LOCALIDADES, genGetLocalidades),
    takeLatest(
      reducerActions.SAGA_SAVE_DIRECCION_ENTREGA,
      genSaveDireccionEntrega
    ),
    takeLatest(reducerActions.SAGA_AGREGAR_LISTABLANCA, genAgregarListaBlanca),
    takeLatest(
      reducerActions.SAGA_ELIMINAR_LISTABLANCA,
      genEliminarListaBlanca
    ),
    takeLatest(reducerActions.SAGA_AGREGAR_LISTANEGRA, genAgregarListaNegra),
    takeLatest(reducerActions.SAGA_ELIMINAR_LISTANEGRA, genEliminarListaNegra),
    takeLatest(
      reducerActions.SAGA_SET_SUCURSALES_USUARIO,
      genSetSucursalesUsuario
    ),
  ])
}

export const sagas = [defaultSaga]
